import { render, staticRenderFns } from "./ItemsPerMonth.vue?vue&type=template&id=c82834d4&scoped=true"
import script from "./ItemsPerMonth.vue?vue&type=script&lang=js"
export * from "./ItemsPerMonth.vue?vue&type=script&lang=js"
import style0 from "./ItemsPerMonth.vue?vue&type=style&index=0&id=c82834d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82834d4",
  null
  
)

export default component.exports